export default [
  {
    path: '/preview/pdf',
    name: 'preview_pdf',
    component: () => import('@/views/preview/PrewviewPDF.vue'),
    meta: {
      title: '预览PDF'
    }
  }
]
